module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/babel-runtime/core-js/map.js
 ** module id = 2828
 ** module chunks = 0
 **/